"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.byCalfColostrumReplacerOutput = void 0;
const graphql_1 = require("../graphql");
const byCalfColostrumReplacer_1 = require("./byCalfColostrumReplacer");
/**
 * ? Note
 * Here alphabets A, B, C, D, etc. are used as key of the inputs.
 * These are the identifiers for denoting the fields as mentioned in Excel sheet.
 * All variables names and excel sheet column identifiers are mapped so that it will be easier to check and
 * validate formulas.
 * this function will call byCalfColostrumReplacer function and according to client scenario only for first feeding we call
 * the function once and if there is second feeding then we call the function twice to show expected results
 */
const byCalfColostrumReplacerOutput = ({ unit: A, desiredMaxAmtForFirstFeeding: B, desiredMaxAmtForSecondFeeding: C, igGInColostrumReplacer: D, birthBodyWt: E, brixReading: F, brixUsedInPrevCalculation: G, }) => {
    /**
     *  ? Note : In any case to calculate first feeding result pass value for argument brixUsedInPrevCalculation as 0
     *  Case 1 : type of feeding is "First feeding" ie (brixUsedInPrevCalculation = 0)
     *  To get first feeding result: value of argument brixReading will be "brixReading" entered by user
     *  Case 2: type of feeding is "second feeding" i.e. (brixUsedInPrevCalculation > 0)
     *  To calculate first feeding result: value of argument brixReading will be brixUsedInPrevCalculation entered by user.
     */
    const firstFdgCalculationResult = (0, byCalfColostrumReplacer_1.byCalfColostrumReplacer)({
        birthBodyWt: E,
        brixReading: G === 0 ? F : G,
        brixUsedInPrevCalculation: 0,
        desiredMaxAmtForFirstFeeding: B,
        desiredMaxAmtForSecondFeeding: C,
        igGInColostrumReplacer: D,
        unit: A,
    });
    /**
     * const to store output/calculated values for second feeding.
     * Second feeding result will get calculated only when type of feeding is "second feeding".
     * to calculate second feeding output values we have to pass both brixReading and brixUsedInPrevCalculation values which received from user
     */
    const secondFdgCalculationResult = (0, byCalfColostrumReplacer_1.byCalfColostrumReplacer)({
        birthBodyWt: E,
        brixReading: F,
        brixUsedInPrevCalculation: G,
        desiredMaxAmtForFirstFeeding: B,
        desiredMaxAmtForSecondFeeding: C,
        igGInColostrumReplacer: D,
        unit: A,
    });
    /**
     * const to store first feeding calculation result
     * */
    const firstFeedingResult = {
        minAmtNeededInFirstFeeding: firstFdgCalculationResult.minAmtNeededInFirstFeeding,
        crPowderNeededInFirstFeeding: firstFdgCalculationResult.crPowderNeededInFirstFeeding,
    };
    /**
     *  if brix used in previous calculation is 0 i.e type of feeding is first feeding
     *  in front end we are not showing values for second feeding
     */
    if (G === 0) {
        return firstFeedingResult;
    }
    /**
     * ? Note : JIRA issue number : 311
     * during second feeding if label 'Lbs/Liters of Colostrum Replacer powder needed in second feeding'
     * i.e. 'amtOfCrUsedInSecondFeeding' is <= 0.02 (for English) or <= 9 (for metric)
     * then for label 'Qts/Liters needed in second feeding' i.e. 'amtNeededInSecondFeeding' should be = Desired Max Qts second feeding (desiredMaxAmtForSecondFeeding)
     * and 'Lbs/Liters of Colostrum Replacer powder needed in second feeding' (amtOfCrUsedInSecondFeeding) should be = 0
     */
    /** const to store amount of powder needed in second feeding */
    const powderNeededInSecondFeeding = Number(secondFdgCalculationResult.amtOfCrUsedInSecondFeeding);
    if ((A === graphql_1.Enum_Measurement_System_Enum.UsCustomary && powderNeededInSecondFeeding <= 0.02) ||
        (A === graphql_1.Enum_Measurement_System_Enum.Metric && powderNeededInSecondFeeding <= 9)) {
        return Object.assign(Object.assign({}, firstFeedingResult), { amtNeededInSecondFeeding: C, amtOfCrUsedInSecondFeeding: 0 });
    }
    /**
     * for first feeding output values we are showing results from firstFdgCalculationResult
     * for second feeding output values we are showing results from firstFdgCalculationResult and secondFdgCalculationResult
     */
    return Object.assign(Object.assign({}, firstFeedingResult), { amtNeededInSecondFeeding: secondFdgCalculationResult.amtNeededInSecondFeeding, amtOfCrUsedInSecondFeeding: secondFdgCalculationResult.amtOfCrUsedInSecondFeeding });
};
exports.byCalfColostrumReplacerOutput = byCalfColostrumReplacerOutput;
exports.default = null;
//# sourceMappingURL=byCalfColostrumReplacerOutput.js.map